import createEnum from 'lib/createEnum';

export const ANSWER_CLEAR_SEARCH_RESULTS = 'self_service/ANSWER_CLEAR_SEARCH_RESULTS';
export const ANSWER_CLEAR_SELECTED_ANSWER = 'self_service/ANSWER_CLEAR_SELECTED_ANSWER';
export const ANSWER_FETCH_SUCCESS = 'self_service/ANSWER_FETCH_SUCCESS';
export const ANSWER_UPDATE_SEARCH_RESULTS = 'self_service/ANSWER_UPDATE_SEARCH_RESULTS';
export const ANSWER_UPDATE_SEARCH_RESULTS_SUCCESS = 'self_service/ANSWER_UPDATE_SEARCH_RESULTS_SUCCESS';
export const ANSWER_UPDATE_SEARCH_TERM = 'self_service/ANSWER_UPDATE_SEARCH_TERM';
export const ANSWER_UPDATE_SELECTED_ANSWER = 'self_service/ANSWER_UPDATE_SELECTED_ANSWER';
export const ANSWER_UPDATE_SELECTED_ANSWER_SUCCESS = 'self_service/ANSWER_UPDATE_SELECTED_ANSWER_SUCCESS';

export const quickActionTypes = createEnum('INTERNAL', 'EXTERNAL');
